<template>
	<app-content class="h-panel">
		<div class="flex px-16px pt-16px items-center justify-between">
			<DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
				<div v-if="params.start!==params.end">{{ fqFormat(params.start) }} 至 {{ fqFormat(params.end) }}</div>
				<div v-else>{{ fqFormat(params.start) }}</div>
				<template #content>
					<Form style="padding: 10px;width: 400px">
						<FormItem class="!pb-5px" label="会计期间">
							<div class="flex items-center">
								<Select @change="dateCheck" v-model="params.start" :deletable="false" filterable :datas="checkoutSelect"/>
								<span class="mx-8px">至</span>
								<Select @change="dateCheck" v-model="params.end" :deletable="false" filterable :datas="checkoutSelect"/>
							</div>
						</FormItem>
						<FormItem class="!pb-5px" label="起始科目">
							<Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName" v-model="params.subjectStart">
								<template #show="{value}">
									{{ value.code }} {{ value.fullName }}
								</template>
								<template #item="{item}">
									{{ item.code }} {{ item.fullName }}
								</template>
							</Select>
						</FormItem>
						<FormItem class="!pb-5px" label="结束科目">
							<Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName" v-model="params.subjectEnd">
								<template #show="{value}">
									{{ value.code }} {{ value.fullName }}
								</template>
								<template #item="{item}">
									{{ item.code }} {{ item.fullName }}
								</template>
							</Select>
						</FormItem>
						<FormItem class="!pb-5px" label="科目级别">
							<div class="flex items-center">
								<Select v-model="params.levelStart" :deletable="false" filterable :datas="[1,2,3,4]"/>
								<span class="mx-8px">至</span>
								<Select v-model="params.levelEnd" :deletable="false" filterable :datas="[1,2,3,4]"/>
							</div>
						</FormItem>
						<FormItem class="!pb-5px">
							<Button color="primary" @click="loadList();" :loading="loading">确定</Button>
							<Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
							<Button @click="resetForm">重置</Button>
						</FormItem>
					</Form>
				</template>
			</DropdownCustom>
			<div class="float-right flex items-center">
				<vxe-button :disabled="datalist.length===0" @click="exportData" icon="fa fa-download" content="导出"/>
				<vxe-button @click="printModel=true;valueRadio='';isReadyPrints=true" icon="fa fa-print" content="打印"/>
			</div>
			<!-- jxd打印弹出框 -->
			<Modal v-model="printModel" v-bind="paramsStyle">
				<div style="
					font-size: 16px;
					border-bottom: 1px solid;
					padding: 6px;">请选择要打印的总账科目</div>
				<div>
					<div><Radio @change="changeRadio" :value='paramRadio[0].key' v-model="valueRadio">打印全部科目</Radio></div>
					<div><Radio @change="changeRadio" :value='paramRadio[1].key' v-model="valueRadio">打印顶级科目</Radio></div>
				</div>
				<div style="display: flex;
					justify-content: right;
					border-top: 1px solid;
					padding: 6px;">
					<div style="margin-top: 6px;">
					<vxe-button @click="printModel=false" icon="vxe-icon-undo" content="取消"/>
					<vxe-button v-print="printAccGl"  @click="printModel=false" icon="vxe-icon-print" :loading="isReadyPrints" content="开始打印"/>
					</div>
				</div>
			</Modal>
		</div>
		<div class="p-16px">
			<Loading text="总账数据加载中..." :loading="loading"></Loading>
			<table class="summary" v-if="!showNumPrice">
				<tr class=" bg-primary-color white-color">
					<td class="w-150px">科目编码</td>
					<td>科目名称</td>
					<td class="w-150px">期间</td>
					<td class="w-150px">摘要</td>
					<td class="w-150px text-right">借方金额</td>
					<td class="w-150px text-right">贷方金额</td>
					<td class="w-150px text-center">方向</td>
					<td class="w-150px text-right">余额</td>
				</tr>
				<template v-for="item in datalist">
					<tr class="bg-gray3-color">
						<td colspan="8">
							<span @click="toggleSummary(item)" class="text-hover">
								<i class="fa fa-caret-down" :class="{'fa-caret-right':!item._expand}"></i>
								<span class="primary-color font-bold ml-8px"> {{ item.subjectName }}</span>
							</span>
						</td>
					</tr>
					<tr v-if="item._expand" class="summary data-row" v-for="it in item.dataRows">
						<td>{{ it.code }}</td>
						<td>
							<router-link 
								class="text-hover primary-color" 
								width="1400px"
								@click.native="loadList()" 
								v-if="it.subjectId"
								:to="{ name: 'DetailedAccounts', params: { subjectIds: it.subjectId, start: params.start, end: params.end } }">
								{{ it.subjectName }}
							</router-link>
						</td>
						<td>{{ it.date }}</td>
						<td>{{ it.summary }}</td>
						<td class="text-right">{{ it.debit != 0 ? it.debit.toFixed(2) : '' }}</td>
						<td class="text-right">{{ it.credit != 0 ? it.credit.toFixed(2) : '' }}</td>
						<td class="text-center">{{ it.balanceDirection }}</td>
						<td class="text-right">{{ it.balance != 0 ? it.balance.toFixed(2) : '' }}</td>
					</tr>
				</template>
				<tr v-if="!datalist.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
			</table>
		</div>
		<!-- 连续打印总账原生模版jxd -->
		<div style="width: 0;height: 0; overflow: hidden;">
			<div id="printMeGl">
				<div v-for="(item,index) in allData" style="width:100%;page-break-before:always;margin:0 auto">
					<p style="font-size: 16px;font-weight: bold;">{{ item.code }}{{ item.subjectName }}总账</p>
					<div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
						<span>科目：{{ item.code }} {{ item.subjectName }}</span>
						<span> {{item.date}} </span>
						<span> 单位：元 </span>
					</div>
					<table style="margin-bottom:4px;margin-top: 4px;border-collapse:collapse;width:100%;">
						<thead style="font-weight:bold;">
							<tr>
								<th style="height:36px;border:1px solid;padding:2px;width:85px;font-size: 14px;">科目编码</th>
								<th style="height:36px;border:1px solid;padding:2px;width:85px;font-size: 14px;">科目名称</th>
								<th style="height:36px;border:1px solid;padding:2px;width:75px;font-size: 14px;">期间</th>
								<th style="height:36px;border:1px solid;padding:2px;width:180px;font-size: 14px;">摘要</th>
								<th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">借方</th>
								<th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">贷方</th>
								<th style="height:36px;border:1px solid;padding:2px;width:35px;font-size: 14px;">方向</th>
								<th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">余额</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(items,index) in item.dataRows">
								<td style="height:30px;text-align: center; font-size: 12px;border:1px solid;padding:2px;width:85px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.code }}</td>
								<td style="height:30px;text-align: center;font-size: 12px;border:1px solid;padding:2px;width:85px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
								<span>{{ items.subjectName }}</span>
								</td>
								<td style="height:30px;font-size: 12px;border:1px solid;padding:2px;width:75px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.date }}</td>
								<!-- jxd word-break: break-all;让纯数字也能换行 -->
								<td style="height:30px;font-size: 12px;border:1px solid;padding:2px;width:180px; word-break: break-all;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.summary }}</td>
								<td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
								<span v-if="items.debit">{{ items.debit.toFixed(2) }}</span>
								</td>
								<td style="text-align: right;height:30px;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
								<span v-if="items.credit">{{ items.credit.toFixed(2) }}</span>
								</td>  
								<td style="height:30px;text-align: center;font-size: 12px;border:1px solid;padding:2px;width:35px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.balanceDirection }}</td>
								<td style="height:30px;text-align: right;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
								<span v-if="items.balance">{{ items.balance.toFixed(2) }}</span>
								</td>
							</tr>
						</tbody>
					</table>
					<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：{{ currentAccountSets.companyName }}</div>
				</div>
			</div>
    	</div>
	</app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import {clone} from "xe-utils";
import setting from "@/api/setting";

const DEFAULT_VALUE = {
  closeOnMask: false,
  fullScreen: false,
  middle: true,
  hasMask: true,
  hasDivider: false,
  hasCloseIcon: true,
  draggable: false
};

export default {
	name: 'GeneralLedger',
	data() {
		return {
			isReadyPrints:true,
			valueRadio:'',
			paramRadio:[{ title: '打印全部科目', key: 'a1'}, { title: '打印顶级科目', key: 'a2' }],
			paramsStyle: {
				...DEFAULT_VALUE
			},
			printModel:false,
			allData:[],
			loading: false,
			accountDate: null,
			showNumPrice: false,
			numPriceDisabled: true,
			datalist: [],
			cloneParams: {},
			subjectList: [],
			params: {
				start: null,
				end: null,
				levelStart: 1,
				levelEnd: 4,
				currencyId: null,
				subjectStart: null,
				subjectEnd: null,
			},
			printAccGl: {
				id: "printMeGl", // 这里是要打印元素的ID
				popTitle: "&nbsp", // 打印的标题
			},
		};
	},
	watch: {
		accountDate() {
			this.loadList();
		},
		showNumPrice() {
			this.loadList();
		}
	},
	computed: {
		...mapState(['currentAccountSets']),
		...mapGetters(['checkoutSelect', 'localCurrency']),
		title() {
			if (!this.params.start) {
				return '';
			}
			if (this.params.start === this.params.end) {
				return manba(this.params.start).format("YYYY年MM期")
			}
			return manba(this.params.start).format("YYYY年MM期") + " - " + manba(this.params.end).format("YYYY年MM期");
		}
	},
	methods: {
		dateCheck(){
			// 定义开始时间和结束时间
			let startDate = new Date(this.params.start);
			let endDate = new Date(this.params.end);
			if(startDate > endDate){
				this.$Message({
				type:'warn',
				text: `开始时间必须早于或等于结束时间！`
				});
			}
		},
		changeRadio(){
			let that = this;
			this.isReadyPrints = true;
			if(this.valueRadio == 'a1'){
				//打印全部科目
				console.log('打印全部科目,无需过滤');
				this.printDataTidy();
			}else{
				//打印顶级科目，过滤掉所有子科目
				console.log('打印顶级科目，过滤掉所有子科目');
				this.printDataTidy('a2');
			}
			that.isReadyPrints = false;
		},
		printDataTidy(flg = 'a1'){
			// 原始数据
			let data = [...this.datalist];
			// 创建一个对象用于存储合并后的内容，键为科目名称(subjectName)，值为一个数组
			let mergedData = {};
			data.forEach(item => {
				let subjectName = item.subjectName;
				if (!mergedData[subjectName]) {
					mergedData[subjectName] = [];
				}
				// 按照日期排序
				item.dataRows.sort((a, b) => new Date(a.date) - new Date(b.date));
				mergedData[subjectName].push(...item.dataRows);
			});
			// 转换回原始格式
			let result = Object.entries(mergedData).map(([subjectName, subjectData]) => ({
				_expand: true,
				dataRows: subjectData,
				subjectId: subjectData[0].subjectId,
				subjectName: subjectName
			}));
			result.forEach(item => {
				item.date = this.title;
				item.code = item.dataRows[0].code;
				for (let i = item.dataRows.length - 1; i >= 1; i--) { // 从后往前遍历，这样在删除元素时不会影响后续索引
					if (item.dataRows[i].summary === '期初余额') {
						item.dataRows.splice(i, 1);
					}
				}
			});
			if(flg == 'a2'){
				let arr = result.filter(item => item.code.length === 4)
				result = arr;
			}
			console.log(result)
			this.allData = result;
		},
		resetForm() {
			this.params = clone(this.cloneParams, true)
		},
		sfilter(item, val) {
			return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
		},
		loadList() {
			this.loading = true;
			accountbook.loadGeneralLedger(Object.assign({}, this.params, {
				showNumPrice: this.showNumPrice
			})).then(({data}) => {
				this.datalist = data;
				this.$refs.paramsDropdown.hide()
			}).finally(() => this.loading = false);
		},
		toggleSummary(item) {
			item._expand = !item._expand
		},
		exportData() {
      		accountbook.downloadLedger(this.datalist.map(val => val.dataRows).flat()).then((data) => {
				downloadBlob(`${manba(this.accountDate).format("YYYY年MM期")}-总账.xls`, data)
			})
		},
		loadSubject() {
			//jxd这里的科目选择应该是所有科目
			setting.subject.listAll().then(({data}) => {
				this.subjectList = data;
			})
			// setting.subject.voucherSelect().then(({data}) => {
			// 	this.subjectList = data;
			// })
		},
	},
	created() {
		this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
		this.params.end = this.params.start;
		this.params.currencyId = this.localCurrency.id;
		this.cloneParams = clone(this.params, true);
		this.loadSubject();
		this.loadList();
	}
};
</script>

<style scoped lang="less">
.summary {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #eee;
    font-size: 12px;
    height: 32px;
  }

  .summary:nth-child(even) {
    background-color: #f8fbf8;
  }

  .summary:hover {
    background-color: #dff7df;
  }


  .header {
    td {
      text-align: center;
      font-weight: bold;
      height: 35px;
    }
  }
}
</style>
